import AddonListComponent from './AddonList';

export default AddonListComponent;
